import React from "react";
import BrandSlider from "./BrandSlider";

function Brands() {
  return (
    <>
      <section class="bg-light py-5">
        <div class="container my-4">
          <div class="row text-center py-3">
            <div class="col-lg-6 m-auto">
              <h1 class="h1">Our Brands</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod Lorem ipsum dolor sit amet.
              </p>
            </div>
            <div class="col-lg-9 m-auto tempaltemo-carousel">
              <BrandSlider />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Brands;
